import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../hooks/redux';
import { store } from '../../store';

// Import from slice instead of actions
import {setFavourites} from '../../slices/myFavouritesSlice';
import {setLoading} from '../../slices/loadingSlice';
import {FavouritesApiService} from "../../api";
import {itemTypes} from '../../enums/ItemTypes.enum';
import i18n from '../../i18n';
import { RootState } from '../../types';
import DataTable from '../DataTable/DataTable';
import ViewHeader from '../ViewHeader';
import FavoritesViewHeaderActions from './FavoritesViewHeaderActions'

const FavoritesOverview = () => {
    const currentUser = useSelector((state: RootState) => state.user)
    const myFavourites = useSelector((state: RootState) => state.myFavourites);
    const favFilter = useSelector((state: RootState) => state.favouriteFilter);
    const dispatch = useAppDispatch();
    

    useEffect(() => {
        const favApi = new FavouritesApiService()
        async function getFav() {
            
            // Set loading state - directly dispatch without setTimeout
            dispatch(setLoading(true));
            
            try {
                // Fetch favorites from the API
                const personalResponse: any = await favApi.getCurrentEntityFav(currentUser.login)
                
                // Handle different response formats (direct or nested in favorite_bookmarks)
                let myFav: any[] = [];
                if (personalResponse && personalResponse['favorite_bookmarks']) {
                    myFav = personalResponse['favorite_bookmarks'];
                } else if (Array.isArray(personalResponse)) {
                    myFav = personalResponse;
                } else {
                    console.warn('Unexpected response format:', personalResponse);
                }
                
                // Update the favorites in the Redux store
                dispatch(setFavourites(myFav))
            } catch (error) {
                console.error('Error fetching favorites:', error);
                // Could dispatch an error action here if needed
            } finally {
                // Always set loading to false when done, directly without setTimeout
                dispatch(setLoading(false));
            }
        }
        // Wait till user login is available to avoid invalid API requests
        currentUser.login && getFav()
    }, [currentUser.login, dispatch])

    // run filtering
    let filteredCardData = []
    if (favFilter) {
        filteredCardData = myFavourites.filter((bmk) => bmk.entity === favFilter)
    } else {
        filteredCardData = myFavourites
    }

    const displayView = <DataTable filteredItems={filteredCardData} itemType={itemTypes.myFavourites} actions = {FavoritesViewHeaderActions()}/>

    return (
        <div>
            <ViewHeader
                title={`${currentUser.login || "user"}'s ${i18n.t('universal:bookmarks')}`}
            />
            {displayView}
        </div>

    );
}

export default function() {
    return (
        <FavoritesOverview />
    );
}
